import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useMaintenanceStore } from '@/modules/maintenance/stores/maintenance.store'
import { ApplicationSetting } from '../types/setting.enum'
import { settingApi } from '../api/setting.api'

export const useSettingStore = defineStore('setting', () => {
  const maintenanceStore = useMaintenanceStore()

  const applicationSettings = ref<ApplicationSetting[]>([
    ApplicationSetting.MaintenanceReminderStart,
    ApplicationSetting.MaintenanceActiveFrom,
    ApplicationSetting.MaintenanceActiveTo,
    ApplicationSetting.MaintenanceReminderInterval,
  ])

  const loadApplicationSettings = async (): Promise<void> => {
    const { data } = await settingApi.getApplicationSettings(applicationSettings.value)
    if (data) {
      maintenanceStore.setMaintenanceSettings(
        data[ApplicationSetting.MaintenanceActiveFrom],
        data[ApplicationSetting.MaintenanceActiveTo],
        data[ApplicationSetting.MaintenanceReminderStart],
        data[ApplicationSetting.MaintenanceReminderInterval],
      )
    }
  }

  return {
    loadApplicationSettings,
  }
})
